module.exports = __webpack_public_path__ + "img/Case presentation Icon - charcoal.a21b8acd.svg";